import { Router, Route, Link, browserHistory,IndexRoute } from 'react-router'
import React from 'react';

import App from './container/App.js'; 
import Login from './container/login';
import Home from './container/home';
import Product from './container/product';
import Signup from './container/signup';
import Profile from './container/profile';
import ApplyExp from './container/applyExp';
import ApplyFixed from './container/applyFixed';
import Class from './container/class';
import ClassFixed from './container/classFixed';
import ApplyMain from './container/applyMain';
import Recharge from './container/recharge';
import Manage from './container/manage';
import MemberPage from './container/member';
import ExpProduct from './container/expProduct';

browserHistory.listen((e)=> {
    window.ga('set', 'page', e.pathname + e.search);
    window.ga('send', 'pageview');
})

const PageRouter = () => {
    return(
        <Router history={browserHistory}>
            <Route path="/" component={App}>

                <IndexRoute component={Home}/>
                <Route path="login(/:pathParam)" component={Login}/>
                <Route path="home" component={Home}/>
                {/*<Route path="my" component={MyPage}>
                    <Route path="calandar(/:pathParam)" component={Calandar}/>
                </Route>*/}
                <Route path="product/:pathParam" component={Product}/>
                <Route path="product/exp/:sign_up_id" component={ExpProduct}/>
                <Route path="signup(/:pathParam)" component={Signup}/>
                <Route path="profile" component={Profile}/>
                <Route path="applyExp" component={ApplyExp}/>
                <Route path="applyFixed" component={ApplyFixed}/>
                <Route path="applyMain" component={ApplyMain}/>
                <Route path="applyMain/success/:amt" component={ApplyMain}/>
                <Route path="class/:class_id" component={Class}/>
                <Route path="classFixed/:class_id" component={ClassFixed}/>
                <Route path="recharge" component={Recharge}/>
                <Route path="manage" component={Manage}/>
                <Route path="member" component={MemberPage}/>
            </Route>
        </Router>
    )
}
export default PageRouter;


/** WEBPACK FOOTER **
 ** ./src/router.js
 **/